export var badgeContainerCSS = {
  pointerEvents: 'none',
  position: 'absolute',
  top: '-4px',
  right: '-2px'
};
export var containerCSS = {
  position: 'relative'
};